<h1 matDialogTitle>{{title}}</h1>
<div mat-dialog-content fxLayout="row" fxLayoutAlign="space-between center" [ngClass]="data.class">
    <mat-icon *ngIf="data.icon" class="mr-16">{{data.icon}}</mat-icon>
    <span>{{confirmMessage}}</span>
</div>
<div mat-dialog-actions class="pt-24">
    <button mat-raised-button class="mat-accent mr-16" (click)="dialogRef.close(true)">{{confirmButtonText}}</button>
    <button mat-button (click)="dialogRef.close(false)">{{cancelButtonText}}</button>
</div>